import { Button, Icon, Notice, Radio, Box } from "@ucloud-fe/react-components";
import "@ucloud/ucloud-icons/dist/ucmp/css/icon_division.min.css";
import { Typography, TextEllipsis } from "@ucloud/ui-components";
import React, { Component } from "react";
import { isMobile } from "../../service/deviceDetectService.js";
import localeService from "../../service/localeService.js";
import { SelectAccountContainer } from "./style.jsx";
const { Text } = Typography;

class SelectUser extends Component {
  constructor(props) {
    super(props);
    const userList = props.phoneUsers || [];
    this.state = {
      userList: userList,
      activeUserId: userList.length && userList[0].UserID,
    };
  }

  render() {
    const { activeUserId, userList } = this.state;
    const { errorMsg } = this.props;
    return (
      <SelectAccountContainer>
        {!isMobile() && (
          <div className="account-title-box">
            {localeService.getTranslate("SELECTACCOUNT")}
          </div>
        )}

        <div
          style={{ display: "inline-block", width: 400, zIndex: 9 }}
          className={`account-list-content ${isMobile() ? "mobile" : ""}`}
        >
          {errorMsg ? (
            <Notice
              className="u-mb12 font-12"
              styleType="error"
              icon="circle-cross"
              message={errorMsg}
            />
          ) : null}
          <Radio.Group
            size="lg"
            styleType="list"
            value={activeUserId}
            onChange={(v) => this.setState({ activeUserId: v })}
          >
            {userList.map((item) => {
              return (
                <div
                  key={item.UserID}
                  className={`account-list-box ${
                    item.UserID === activeUserId && "active-account"
                  } `}
                >
                  {isMobile() && (
                    <Icon
                      className="account-icon-right"
                      type="right"
                      prefix="icon__"
                    />
                  )}
                  <Radio
                    size="lg"
                    className="account-radio"
                    value={item.UserID}
                    key={item.UserID}
                    onClick={() => {
                      if (!isMobile()) return;
                      const activeUserInfo = userList.filter(
                        (u) => u.UserID === item.UserID
                      );
                      this.props.userLoginChange(
                        activeUserInfo && activeUserInfo[0]
                      );
                    }}
                  >
                    <div className="account-info-box">
                      <div className="account-name">
                        <TextEllipsis.LineEllipsis text={item.UserName} />
                      </div>
                      <div
                        className={`account-type ${
                          item.Admin ? "t-main" : "t-sub"
                        }`}
                      >
                        {isMobile() && (
                          <Icon type="user-avatar-fill" prefix="icon-ucmp__" />
                        )}

                        {localeService.getTranslate(
                          item.Admin ? "PRIMARYACCOUNT" : "SUBACCOUNT"
                        )}
                      </div>
                    </div>
                  </Radio>
                </div>
              );
            })}
          </Radio.Group>
          <div className="notice-box normal-text font-14">
            {localeService.getTranslate("NAPLTN1")}
            <Text color="dark" className="weight mr-4 ml-4">
              {localeService.getTranslate("CONSOLE_ACCOUNTM")}
            </Text>
            {localeService.getTranslate("OPLIN2")}
          </div>
          {!isMobile() && (
            <Button
              size="lg"
              styleType="primary"
              className="u-mt24 login-btn"
              onClick={() => {
                const activeUserInfo = userList.filter(
                  (u) => u.UserID === activeUserId
                );
                this.props.userLoginChange(activeUserInfo && activeUserInfo[0]);
              }}
            >
              {localeService.getTranslate("TOCONDOLE")}
            </Button>
          )}
          <Button
            size="lg"
            className="u-mt24 login-btn cancel-btn"
            onClick={() => {
              this.props.cancelLoginChange();
            }}
          >
            {localeService.getTranslate("CANCELLOGIN")}
          </Button>
        </div>
      </SelectAccountContainer>
    );
  }
}

export default SelectUser;



// WEBPACK FOOTER //
// src/pc/components/SelectUser.jsx